import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _isLoading = new BehaviorSubject<number>(0);
  isLoading$ = this._isLoading.asObservable();

  show() {
    this._isLoading.next(this._isLoading.value + 1);
  }

  hide() {
    this._isLoading.next(this._isLoading.value - 1);
  }

  isLoading() {
    return this._isLoading.value > 0;
  }
}
